<template>
  <section id="formats">
    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
    <v-container fluid>
      <v-col cols="12" class="text-center">
        <h1 class="font-weight-bold text-primary">
          Asegura un Servicio Profesional con Nuestros Formatos Personalizados
        </h1>
        <h2 class="font-weight-bold text-secondary">
          Elige el Formato que Mejor se Adapte a Tu Taller
        </h2>
      </v-col>
      <v-carousel height="100%" hide-delimiters style="margin-bottom: 2%">
        <v-carousel-item v-for="(slide, index) in slides" :key="index">
          <v-row class="card-large">
            <!-- Contenido de texto -->
            <v-col
              cols="12"
              md="6"
              class="d-flex flex-column justify-center align-center px-5"
            >
              <h2 class="card-large-title">{{ slide.title }}</h2>
              <img :src="slide.gif" :alt="slide.title" class="card-gif1" />
              <p class="card-large-description">{{ slide.description }}</p>
              <v-btn
                v-if="slide.whatsappURL"
                rounded
                color="#9ABE23"
                :href="slide.whatsappURL"
                target="_blank"
                style="align-self: center; color: white"
              >
                <v-icon left> mdi-whatsapp </v-icon>
                Me interesa este formato
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-center">
              <img
                :src="slide.image"
                class="card-large-image"
                alt="Formato"
                @click="openImage(slide.image)"
              />
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
      <beneficios />
      <v-col cols="12" class="text-center">
        <h1 class="font-weight-bold text-primary">
          Optimiza tu Taller y Aumenta tus Ganancias con OSD
        </h1>
        <h2 class="font-weight-bold text-secondary">
          ¿Qué te ofrecemos para optimizar tu taller?
        </h2>
      </v-col>
      <div class="card-container1">
        <div class="card-container">
          <div class="card" v-for="(group, index) in baseFeatures" :key="index">
            <img :src="group.image" :alt="group.title" class="card-gif" />
            <h3 class="card-title">{{ group.title }}</h3>
            <p class="card-description">{{ group.description }}</p>
          </div>
        </div>
      </div>
      <v-dialog v-model="dialog" max-width="90vw">
        <v-card>
          <v-img :src="selectedImage" class="dialog"></v-img>
        </v-card>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
import baseDatosCliente from "@/assets/gifs/base_datos_cliente.gif";
import baseInventario from "@/assets/gifs/base_inventario.gif";
import baseDanios from "@/assets/gifs/base_danios.gif";
import baseimagenes from "@/assets/gifs/base_imagenes.gif";
import basecontrato from "@/assets/img/base_contrato.jpg";

import trabajoTextarea from "@/assets/img/trabajo_textarea.jpg";
import cotizacionTabla from "@/assets/img/cotizacion_tabla.jpg";
import detallesServicio from "@/assets/img/detalles_servicio.jpg";
import aseguradorasExtras from "@/assets/img/aseguradoras_extras.jpg";

import Basico from "@/assets/gifs/basico.gif";
import Cotización from "@/assets/gifs/cotización.gif";
import Politicas from "@/assets/gifs/politicas.gif";
import Aseguradora from "@/assets/gifs/aseguradora.gif";
import Beneficios from "./Beneficios.vue";

export default {
  components: { Beneficios },
  data() {
    return {
      dialog: false,
      selectedImage: null,
      whatsappBaseURL: "https://wa.me/+5214434846542?text=",
      mensaje: "Quiero más información sobre la OSD",
      slides: [],
      baseFeatures: [
        {
          title: "Gestión Rápida y Precisa de Clientes y Vehículos",
          description:
            "Registra información esencial del cliente y del vehículo de forma clara y ordenada. Incluye datos clave como modelo, placas, y contacto para asegurar precisión en cada servicio.",
          image: baseDatosCliente,
        },
        {
          title: "Evita Errores y Protege tu Negocio con un Registro Completo",
          description:
            "Lleva un control detallado del inventario del vehículo, selecciona testigos encendidos, y registra el nivel de gasolina de manera precisa. Perfecto para respaldar tu servicio con información confiable.",
          image: baseInventario,
        },
        {
          title: "Mayor Transparencia con un Registro Visual de Daños",
          description:
            "Marca los daños en diferentes vistas del vehículo con un sistema intuitivo. Incluye áreas para las firmas del cliente y del taller, garantizando transparencia en el servicio.",
          image: baseDanios,
        },
        {
          title: "Evidencia Clara para Evitar Malentendidos y Reclamos",
          description:
            "Permite cargar imágenes del vehículo y añadir una descripción detallada para cada daño identificado. Ideal para llevar un control visual claro y organizado dentro de la orden de servicio.",
          image: baseimagenes,
        },
        {
          title: "Garantiza Acuerdos Claros y Seguridad Legal",
          description:
            "Incluye un contrato detallado de adhesión para formalizar el acuerdo entre el taller y el cliente. Se asegura que ambas partes están de acuerdo con los términos y condiciones del servicio prestado.",
          image: basecontrato,
        },
      ],
    };
  },
  created() {
    this.slides = [
      {
        gif: Basico,
        title: "Orden de Servicio Básica con Detalles de Trabajo",
        description:
          "Perfecta para talleres que requieren una descripción libre y detallada del trabajo realizado. Añade observaciones personalizadas para cada servicio, asegurando que se registre toda la información relevante y que el cliente esté completamente informado sobre lo que se ha realizado.",
        image: trabajoTextarea,
        whatsappURL: this.whatsappBaseURL + encodeURIComponent(this.mensaje),
      },
      {
        gif: Cotización,
        title: "Orden de Servicio con Cotización",
        description:
          "Ideal para talleres que necesitan gestionar costos de manera clara y precisa. Permite calcular los costos de mano de obra, repuestos y otros conceptos, mostrando subtotales, impuestos (IVA) y el total final. Con una tabla interactiva que facilita la visualización de todos los detalles económicos, asegurando transparencia con el cliente.",
        image: cotizacionTabla,
        whatsappURL: this.whatsappBaseURL + encodeURIComponent(this.mensaje),
      },
      {
        gif: Politicas,
        title: "Orden de Servicio con Detalles y Políticas Personalizadas",
        description:
          "Este formato permite agregar detalles específicos sobre el servicio realizado y personalizar las políticas de trabajo, asegurando que el cliente conozca las condiciones del servicio y los plazos. Ideal para talleres que ofrecen garantías, condiciones particulares o acuerdos previos a los trabajos.",
        image: detallesServicio,
        whatsappURL: this.whatsappBaseURL + encodeURIComponent(this.mensaje),
      },
      {
        gif: Aseguradora,
        title: "Orden de Servicio para Aseguradoras",
        description:
          "Diseñada específicamente para gestionar órdenes de servicio relacionadas con aseguradoras. Incluye los campos necesarios para cumplir con los requisitos de las aseguradoras y manejar trabajos bajo sus condiciones. Perfecta para talleres que colaboran con seguros, asegurando un flujo de trabajo ágil y conforme a las normativas del sector.",
        image: aseguradorasExtras,
        whatsappURL: this.whatsappBaseURL + encodeURIComponent(this.mensaje),
      },
    ];
  },
  methods: {
    openImage(imageUrl) {
      this.dialog = true;
      this.selectedImage = imageUrl;
    },
  },
};
</script>

<style scoped>
#formats {
  background-color: transparent;
  padding: 20px 0;
  z-index: 0;
}

.img-responsive {
  max-width: 70%;
  height: auto;
}

.dialog {
  max-width: 100%;
  height: auto;
}

.containerrow {
  padding: 4rem;
}

.text-primary {
  color: #9abe23; /* Azul primario */
  font-size: 1.5rem;
}

.text-secondary {
  color: #555555; /* Gris secundario */
  font-size: 1.1rem;
}

.v-btn {
  border: 2px solid #9abe23; /* Borde verde */
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-container1 {
  width: 100%;
}

.card-container {
  width: 85%;
  margin: 0 auto; /* Centra horizontalmente el contenedor */
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  padding: 1rem;
  background-color: #f6f6f600;
}

.card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  padding: 1rem;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
}

.card-gif {
  max-height: 150px;
  max-width: 100%;
  border-radius: 4px;
}

.card-gif1 {
  max-width: 15%;
  height: auto;
  border-radius: 4px;
  filter: saturate(0.9) hue-rotate(-90deg);
}

.card-title {
  font-size: 1.2rem;
  color: #9abe23; /* Azul primario */
  font-weight: bold;
  margin: 0.5rem 0;
}

.card-description {
  font-size: 0.9rem;
  color: #555;
}

.card-large {
  width: 80%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.card-large-title {
  font-size: 1.4rem;
  color: #9abe23; /* Azul primario */
  font-weight: bold;
  margin-bottom: 1rem;
}

.card-large-description {
  font-size: 1rem;
  color: #555555; /* Gris secundario */
  line-height: 1.5;
}

.card-large-image {
  max-width: 80%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra para destacar */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Animación suave */
}

.card-large-image:hover {
  transform: scale(1.05); /* Pequeño efecto de zoom al pasar el cursor */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3); /* Aumenta la sombra al pasar el cursor */
}

.svg-border-waves img {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
  transform: scale(-1, -1); /* Invierte la imagen en ambas direcciones */
  transform-origin: center; /* Asegura que la transformación sea centrada */
}

@media (max-width: 768px) {
  .card-large-image {
    max-width: 100%;
  }
  .card-gif1 {
    max-width: 50%;
  }
  .card-large-description {
    font-size: 0.8rem;
  }
  .text-primary {
    font-size: 1.4rem;
  }
  .text-secondary {
    font-size: 0.9rem;
  }
  .card-large-title {
    font-size: 1.2rem;
  }
  .card-large-description {
    font-size: 0.9rem;
  }
  .card-title {
    font-size: 1.2rem;
  }
  .card-description {
    font-size: 0.8rem;
  }
}
</style>
